import { useQuery } from "react-query";
import axios from "axios";

import { Col, Row } from "antd";
import { withTranslation } from "react-i18next";
import { Content, ContentWrapper, StatsBlockSection } from "./styles";
import { SvgIcon } from "../../common/SvgIcon";

interface StatsBlockProps {
  title: string;
  content: string;
  t: any;
  section: any
}

const StatsBlock = ({ title, content, section, t }: StatsBlockProps) => {
  const { isLoading, data } = useQuery(
    'stats',
    () => {
      return axios.get(process.env.REACT_APP_BE_URL + "/api/stats")
    }, {
    cacheTime: 10000
  })

  const formattedNumber = (number: number) => {
    return new Intl.NumberFormat().format(number)
  }

  return (
    <StatsBlockSection>
      <Row justify="center" align="middle">
        <ContentWrapper>
          <Col lg={24} md={24} sm={24} xs={24}>
            <h6>{t(title)}</h6>
            <Content>{t(content)}</Content>
            {typeof data?.data === "object" &&
              <Row justify="space-between" align="middle">
                <Col lg={8} md={8} sm={12} xs={24}>
                  <SvgIcon src="networks.svg" width="100px" height="100px" />
                  <Content>{t(data?.data.networks_count)}<br />Networks</Content>
                </Col>
                <Col span={8}>
                  <SvgIcon src="handshake.svg" width="100px" height="100px" />
                  <Content>{t(formattedNumber(data?.data.total_delegators))}<br />Total Delegators</Content>
                </Col>
                <Col span={8}>
                  <SvgIcon src="staked_assets.svg" width="100px" height="100px" />
                    <Content>{t(formattedNumber(data?.data.total_staked_usd))} $<br/>Secured Assets</Content>
                </Col>
              </Row>
            }
          </Col>
        </ContentWrapper>
      </Row>

    </StatsBlockSection>
  );
};

export default withTranslation()(StatsBlock);